var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_icon_Calendar",
    "data-name": "Controls/icon/Calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2282",
    "data-name": "Rectangle 2282",
    width: 38,
    height: 38,
    fill: "none",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2877",
    "data-name": "Group 2877",
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2876",
    "data-name": "Group 2876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3745",
    "data-name": "Path 3745",
    d: "M47.61,15.875H18.16a3.3,3.3,0,0,0-3.275,3.31V46.565a3.3,3.3,0,0,0,3.275,3.31H47.61a3.3,3.3,0,0,0,3.275-3.31V19.185A3.3,3.3,0,0,0,47.61,15.875Zm0,30.991H18.16a.3.3,0,0,1-.3-.3V23.591H47.908V46.565A.3.3,0,0,1,47.61,46.866Z",
    transform: "translate(-14.885 -15.875)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2283",
    "data-name": "Rectangle 2283",
    width: 2.948,
    height: 2.98,
    transform: "translate(13.577 10.961)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2284",
    "data-name": "Rectangle 2284",
    width: 2.948,
    height: 2.98,
    transform: "translate(19.474 10.961)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2285",
    "data-name": "Rectangle 2285",
    width: 2.949,
    height: 2.98,
    transform: "translate(25.371 10.961)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2286",
    "data-name": "Rectangle 2286",
    width: 2.949,
    height: 2.98,
    transform: "translate(7.68 16.92)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2287",
    "data-name": "Rectangle 2287",
    width: 2.948,
    height: 2.98,
    transform: "translate(13.577 16.92)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2288",
    "data-name": "Rectangle 2288",
    width: 2.948,
    height: 2.98,
    transform: "translate(19.474 16.92)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2289",
    "data-name": "Rectangle 2289",
    width: 2.949,
    height: 2.98,
    transform: "translate(25.371 16.92)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2290",
    "data-name": "Rectangle 2290",
    width: 2.949,
    height: 2.98,
    transform: "translate(7.68 22.88)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2291",
    "data-name": "Rectangle 2291",
    width: 2.948,
    height: 2.98,
    transform: "translate(13.577 22.88)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2292",
    "data-name": "Rectangle 2292",
    width: 2.948,
    height: 2.98,
    transform: "translate(19.474 22.88)",
    fill: "#75787b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.3fe7f64dee545a6a8ead4cc0662c8326.svg";
export { ForwardRef as ReactComponent };